import {
  Box,
  Typography,
  Avatar,
  Stack,
  CircularProgress,
} from "@mui/material";

import { useState } from "react";
import TextInput from "../textfields";
import { contact_support } from "@/constants";
import { TextContainer } from "./styles";
import { useCreateSupportMutation } from "@/services";
import { ContainedButton } from "@/common";
import { useSnackbar } from "@/hooks";

const initialState = { subject: "", message: "" };

const ContactUsForm = ({ onClose }: { onClose?: () => void }) => {
  const [formData, setFormData] = useState(initialState);

  const { subject, message } = formData;

  const [createSupport, { isLoading }] = useCreateSupportMutation();
  const { show } = useSnackbar();

  const handleFormChange = (name: keyof typeof formData) => (value: string) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createSupport({
        support: { message, subject },
      }).unwrap();
      onClose?.();
      setFormData(initialState);
      show(
        "Thank you for reaching out! Your message has been sent successfully.",
        "",
        "success"
      );
    } catch (error: any) {
      show(error.message, "", "error");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        height: "100%",
      }}
    >
      <Box display="flex" flexDirection="column" gap="28px">
        <Avatar
          sx={{ width: "76px", height: "76px" }}
          src={contact_support}
          alt="avatar"
        />
        <Stack spacing={2}>
          <Typography
            sx={{
              fontSize: "42px",
              fontWeight: 500,
              lineHeight: "110%",
              alignSelf: "stretch",
            }}
            mt={2}
          >
            Get in touch with us!
          </Typography>

          <Typography sx={{ fontSize: "18px", color: "#8D9299" }}>
             Need help with something? Fill out the form and we'll get back to you shortly.
          </Typography>
        </Stack>
      </Box>
      <form onSubmit={handleSubmit}>
        <TextContainer>
          <TextInput
            label="Subject"
            placeholder="Enter Subject here"
            fullWidth
            type="text"
            name="subject"
            value={subject}
            handleChangeValue={handleFormChange("subject")}
          />
        </TextContainer>
        <TextContainer mb={2}>
          <TextInput
            label="Message"
            placeholder="Leave us a message"
            fullWidth
            multiline
            rows={6}
            type="text"
            name="message"
            value={message}
            handleChangeValue={handleFormChange("message")}
          />
        </TextContainer>
        <ContainedButton
          type="submit"
          variant="contained"
          disabled={isLoading}
          title=" Send Message"
          fullWidth
          {...(isLoading && {
            startIcon: <CircularProgress sx={{ color: "white" }} size={20} />,
          })}
        />
      </form>
    </Box>
  );
};

export default ContactUsForm;
